<div id="registrationForm">
  <div class="registration-shell">
    <header class="registration-header">
      <div class="brand-lockup">
        <img id="registration-logo" [src]="logo" alt="Lead Advantage Pro" />
        <div class="brand-copy">
          <p class="eyebrow">Secure account registration</p>
          <h1>Register for Lead Advantage Pro</h1>
          @if (!displayInvalidAcct) {
            <p class="brand-mission">
              Leverage your time, make more money and put your business in a position of distinction with Lead Advantage Pro!
            </p>
          }
        </div>
      </div>

      @if (!displayInvalidAcct) {
        <div class="trust-bar" aria-label="Registration security and compliance details">
          <div>
            <mat-icon aria-hidden="true">verified_user</mat-icon>
            <span>Secure credential setup</span>
          </div>
          <div>
            <mat-icon aria-hidden="true">badge</mat-icon>
            <span>NPN validation support</span>
          </div>
          <div>
            <mat-icon aria-hidden="true">admin_panel_settings</mat-icon>
            <span>Agency account assignment</span>
          </div>
        </div>
      }
    </header>

    <main class="registration-panel">
      @if (!componentLoaded || inProgress) {
        <div class="loading-panel">
          <app-sms-spinner [data]="loadingMessage" size="1x"></app-sms-spinner>
        </div>
      } @else {
        @if (displayInvalidAcct || displayRoleExpired || displayAcctInfo ||  (registrationMessage$ | async)) {
          @if ((registrationMessage$ | async) == '') {
            <mat-card appearance="outlined" class="regFormNotice" role="alert" [ngClass]="{
                'alert': displayInvalidAcct || displayRoleExpired
              }">
              <mat-card-content>
                <div class="notice-content">
                  <mat-icon class="notice-icon" aria-hidden="true" [ngClass]="{ 'warn-alt': displayAcctInfo }">
                    @if (displayInvalidAcct || displayRoleExpired) {
                      warning
                    } @else {
                      warning_amber
                    }
                  </mat-icon>
                  <p>
                    @if (displayInvalidAcct) {
                      <span>
                        The registration link used is no longer valid. Please contact Lead Advantage Pro support at 1-877-645-0147. If you'd like to register for Lead Advantage Pro please visit Lead Advantage Pro at <a href="https://seniormarketsales.com" target="_blank" rel="noopener noreferrer">https://seniormarketsales.com</a>.
                      </span>
                    }
                    @if (displayRoleExpired) {
                      <span>
                        Please contact {{ accountOwnerName }} at {{ accountOwnerEmail }} or <span>{{ accountOwnerPhone | phone }}</span> as the user role is no longer valid for this link.
                      </span>
                    }
                    @if (displayAcctInfo) {
                      <span>
                        Your registration will create a user profile within {{ accountOwnerName }}'s Lead Advantage Pro account ({{ accountId }}). If this is not what you intend, do not proceed. You may contact {{accountOwnerName}} at {{accountOwnerEmail}}@if (accountOwnerPhone) {
                        <span> or {{ accountOwnerPhone | phone }}</span>
                        }.
                      </span>
                    }
                  </p>
                  <button mat-icon-button type="button" aria-label="Close notice" (click)="closeNotice()">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
          }
          @if (registrationAttempt && (registrationMessage$ | async)) {
            <mat-card appearance="outlined" class="regFormNotice" role="alert" [ngClass]="{
                'alert': hasError,
                'success': !hasError
              }">
              <mat-card-content>
                <div class="notice-content">
                  <mat-icon class="notice-icon" aria-hidden="true">
                    @if (!hasError) {
                      done
                    } @else {
                      warning
                    }
                  </mat-icon>
                  @if (registrationMessage$ | async; as regMessage) {
                    <p [innerHTML]="regMessage"></p>
                  }
                  <button mat-icon-button type="button" aria-label="Close notice" (click)="closeNotice()">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
          }
        }

        @if (!displayInvalidAcct) {
          <div class="registration-workspace">
          <form id="userRegistrationForm" class="registration-form-card" name="userRegistrationForm" aria-label="Lead Advantage Pro user registration" novalidate method="POST" autocomplete="off" (submit)="submitForm()" [formGroup]="userRegistrationForm">
            <div class="form-intro">
              <div>
                <p class="eyebrow">Registration details</p>
                <h2>Complete your profile</h2>
              </div>
              <p><span class="requiredIndicator">*</span> denotes a required field.</p>
            </div>

            <mat-card appearance="outlined" class="registration-section">
              <mat-card-content>
                <div class="section-heading">
                  <div class="section-icon">
                    <mat-icon aria-hidden="true">lock</mat-icon>
                  </div>
                  <div>
                    <mat-card-title>Account Credentials</mat-card-title>
                    <p>Create credentials for access to protected insurance account data.</p>
                  </div>
                </div>

                <div class="form-grid single-field">
                  <mat-form-field >
                    <mat-label>Username</mat-label>
                    <input matInput autocomplete="new-password" required aria-required="true" name="login" maxlength="15" formControlName="login" />
                    <mat-hint>6-15 letters or numbers</mat-hint>
                    @if (login.hasError('required')) {
                      <mat-error>Username is <strong>required</strong>.</mat-error>
                    }
                    @if (login.hasError('minlength') || login.hasError('maxlength') || login.hasError('pattern')) {
                      <mat-error>Username must be <strong>6-15 letters or numbers</strong>.</mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="form-grid credentials-grid">
                  <div class="stacked-fields">
                    <mat-form-field>
                      <mat-label>Password</mat-label>
                      <input matInput autocomplete="new-password" required name="password" [type]="hidePassword ? 'password' : 'text'" formControlName="password" aria-describedby="passwordStrengthText" />
                      <button mat-icon-button matSuffix type="button" [attr.aria-label]="hidePassword ? 'Show password' : 'Hide password'" [attr.aria-pressed]="!hidePassword" (click)="hidePassword = !hidePassword">
                        <mat-icon aria-hidden="true">{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
                      </button>
                      @if (password.hasError('required')) {
                        <mat-error>Password is <strong>required</strong>.</mat-error>
                      }
                      @if (password.hasError('pattern')) {
                        <mat-error>Password must meet the <strong>minimum strength</strong> as defined.</mat-error>
                      }
                    </mat-form-field>
                    <div class="password-strength" [ngClass]="'strength-' + getPasswordStrength()" aria-live="polite">
                      <div class="strength-track" aria-hidden="true">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <p id="passwordStrengthText">Password strength: {{ getPasswordStrengthLabel() }}</p>
                    </div>
                    <mat-form-field>
                      <mat-label>Confirm Password</mat-label>
                      <input matInput autocomplete="new-password" required name="confirmPwd" [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirmPwd" />
                      <button mat-icon-button matSuffix type="button" [attr.aria-label]="hideConfirmPassword ? 'Show confirm password' : 'Hide confirm password'" [attr.aria-pressed]="!hideConfirmPassword" (click)="hideConfirmPassword = !hideConfirmPassword">
                        <mat-icon aria-hidden="true">{{ hideConfirmPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
                      </button>
                      @if (confirmPwd.hasError('required')) {
                        <mat-error>Must <strong>confirm</strong> Password.</mat-error>
                      }
                      @if (confirmPwd.hasError('confirmedValidator')) {
                        <mat-error>Password must <strong>match</strong>.</mat-error>
                      }
                    </mat-form-field>
                  </div>

                  <div class="requirement-panel">
                    <p>Minimum password standard</p>
                    <ul>
                      @for (req of getPasswordRequirements(); track req.label) {
                        <li [class.req-met]="req.met" [class.req-unmet]="!!password.value && !req.met">
                          <mat-icon aria-hidden="true">{{ req.met ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                          {{ req.label }}
                        </li>
                      }
                    </ul>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <mat-card appearance="outlined" class="registration-section">
              <mat-card-content>
                <div class="section-heading">
                  <div class="section-icon">
                    <mat-icon aria-hidden="true">person</mat-icon>
                  </div>
                  <div>
                    <mat-card-title>Contact Information</mat-card-title>
                    <p>Provide information used for account ownership, servicing, and agency communications.</p>
                  </div>
                </div>

                <div class="form-grid two-column">
                  <mat-form-field>
                    <mat-label>Business Name</mat-label>
                    <input matInput name="business" maxlength="50" formControlName="company" />
                  </mat-form-field>
                </div>

                <div class="form-grid two-column">
                  <mat-form-field>
                    <mat-label>First Name</mat-label>
                    <input matInput required name="fname" formControlName="fname" />
                    @if (fname.hasError('required')) {
                      <mat-error>First Name is <strong>required</strong>.</mat-error>
                    }
                    @if (fname.hasError('pattern')) {
                      <mat-error>First Name must contain <strong>letters, spaces,</strong> and <strong>hyphens</strong> only.</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Last Name</mat-label>
                    <input matInput required name="lname" formControlName="lname" />
                    @if (lname.hasError('required')) {
                      <mat-error>Last Name is <strong>required</strong>.</mat-error>
                    }
                    @if (lname.hasError('pattern')) {
                      <mat-error>Last Name must contain <strong>letters, spaces,</strong> and <strong>hyphens</strong> only.</mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="form-grid two-column">
                  <mat-form-field>
                    <mat-label>Email Address</mat-label>
                    <input matInput required aria-required="true" type="email" name="email" formControlName="email" />
                    @if (email.hasError('required')) {
                      <mat-error>Email Address is <strong>required</strong>.</mat-error>
                    }
                    @if (email.hasError('email')) {
                      <mat-error>Enter a <strong>valid</strong> Email Address.</mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="form-grid two-column">
                  <mat-form-field>
                    <mat-label>Street Address 1</mat-label>
                    <input matInput required name="address1" formControlName="address1" />
                    @if (address1.hasError('required')) {
                      <mat-error>Street Address 1 is <strong>required</strong>.</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Street Address 2</mat-label>
                    <input matInput name="address2" formControlName="address2" />
                  </mat-form-field>
                </div>

                <div class="form-grid three-column">
                  <mat-form-field>
                    <mat-label>City</mat-label>
                    <input matInput required name="city" formControlName="city" />
                    @if (city.hasError('required')) {
                      <mat-error>City is <strong>required</strong>.</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>State</mat-label>
                    <mat-select required name="state" formControlName="state_id">
                      @for (state of statesList; track state) {
                        <mat-option [value]="state.abbreviation">{{state.name}}</mat-option>
                      }
                    </mat-select>
                    @if (state_id.hasError('required')) {
                      <mat-error>State is <strong>required</strong>.</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Zip Code</mat-label>
                    <input matInput required name="zip" maxlength="5" appNumbersOnly formControlName="zip" />
                    <mat-hint>Five digit number</mat-hint>
                    @if (zip.hasError('required')) {
                      <mat-error>Zip Code is <strong>required</strong>.</mat-error>
                    }
                    @if (zip.hasError('pattern')) {
                      <mat-error>Enter a <strong>valid</strong> Zip Code.</mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="inline-note">
                  <mat-icon aria-hidden="true">info</mat-icon>
                  <p>A business phone or mobile phone is required so operations teams can verify and service the account.</p>
                </div>

                <div class="form-grid two-column">
                  <mat-form-field>
                    <mat-label>Business Phone</mat-label>
                    <input matInput type="tel" name="phone" maxlength="14" appPhoneNumberMask formControlName="phone" />
                    <mat-hint>Ten digit number</mat-hint>
                    @if (phone.hasError('pattern')) {
                      <mat-error>Enter a <strong>valid</strong> Business Phone.</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Mobile Phone</mat-label>
                    <input matInput type="tel" name="mphone" maxlength="14" appPhoneNumberMask formControlName="mphone" />
                    <mat-hint>Ten digit number</mat-hint>
                    @if (mphone.hasError('pattern')) {
                      <mat-error>Enter a <strong>valid</strong> Mobile Phone.</mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="inline-note">
                  <mat-icon aria-hidden="true">sms</mat-icon>
                  <p>After registration is complete, you will be able to configure Communication Preferences to receive transactional text messages. <span>A mobile phone number must be on file.</span></p>
                </div>

                <div class="form-grid two-column">
                  <mat-form-field>
                    <mat-label>Fax Number</mat-label>
                    <input matInput type="tel" name="fphone" maxlength="14" appPhoneNumberMask formControlName="fphone" />
                    @if (fphone.hasError('pattern')) {
                      <mat-error>Enter a <strong>valid</strong> Fax Number.</mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="form-grid npn-grid">
                  <mat-form-field>
                    <mat-label>National Producer Number (NPN)</mat-label>
                    <input matInput name="npn" formControlName="npn" [readonly]="hasNoNPN.value == true" />
                    @if (npn.hasError('pattern') || npn.hasError('missingNPN')) {
                      <mat-error>Enter a <strong>valid</strong> NPN or click the checkbox if you do not have one.</mat-error>
                    }
                  </mat-form-field>
                  <div id="npnSearch" class="npn-actions">
                    @if (!displayInvalidAcct && !displayRoleExpired) {
                      <a href="https://www.nipr.com/PacNpnSearch.htm" target="_blank" rel="noopener noreferrer">Find your NPN</a>
                      <mat-checkbox formControlName="hasNoNPN">I don't have an NPN</mat-checkbox>
                    }
                  </div>
                </div>

                <div class="form-grid two-column">
                  <mat-form-field>
                    <mat-label>Website URL</mat-label>
                    <input matInput name="website" formControlName="website" />
                  </mat-form-field>
                </div>
              </mat-card-content>

              @if ((!userRegistrationForm.pristine && !hasError) || !disabledAccount) {
                <mat-card-actions align="end">
                  <button [disabled]="inProgress || userRegistrationForm.disabled" mat-flat-button color="primary" type="submit" aria-label="Submit registration">
                    <mat-icon aria-hidden="true" [class.spin-icon]="inProgress">{{ inProgress ? 'sync' : 'how_to_reg' }}</mat-icon>
                    {{ inProgress ? 'Submitting...' : 'Submit Registration' }}
                  </button>
                </mat-card-actions>
              }
            </mat-card>
          </form>
          <aside class="registration-side-panel" aria-label="Registration guidance">
            <div>
              <p class="eyebrow">Insurance portal access</p>
              <h2>Secure producer onboarding</h2>
              <p>
                This registration establishes a profile for agency-facing workflows, producer identification, and protected client servicing tools.
              </p>
            </div>
            <ul>
              <li>
                <mat-icon aria-hidden="true">shield_lock</mat-icon>
                <span>Credentials are required before access to account data is granted.</span>
              </li>
              <li>
                <mat-icon aria-hidden="true">assignment_ind</mat-icon>
                <span>NPN information helps align producer records with insurance operations.</span>
              </li>
              <li>
                <mat-icon aria-hidden="true">support_agent</mat-icon>
                <span>Use accurate contact details for account verification and service follow-up.</span>
              </li>
            </ul>
            <div class="support-block">
              <span>Need registration assistance?</span>
              <strong>1-877-645-0147</strong>
            </div>
          </aside>
          </div>
        }
      }
    </main>
  </div>
</div>
